module.exports = __webpack_public_path__ + "assets/img/home-download-bg.5deaaff1.gif";